import React from 'react';

const ErrorPage = () => {
  return <>404 Not Found!</>;
};

export default ErrorPage;
